"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _accLocationsComponents = require("@adsk/acc-locations-components");

var _differenceBy = _interopRequireDefault(require("lodash/differenceBy"));

var _sortBy = _interopRequireDefault(require("lodash/sortBy"));

var _alloyReactInlineEdit = _interopRequireDefault(require("@adsk/alloy-react-inline-edit"));

var _alloyReactTheme = _interopRequireDefault(require("@adsk/alloy-react-theme"));

var _alloyReactHelpers = require("@adsk/alloy-react-helpers");

var _alloySelectBox = _interopRequireDefault(require("@adsk/alloy-select-box"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Spacer = _interopRequireDefault(require("../../shared/Spacer"));

var _routes = require("../../../util/routes");

var _Tags = _interopRequireDefault(require("../Tags"));

var _mediaDetailContext = require("../media-detail-context");

var _PlangridLaunchDarklyProvider = require("../../../util/PlangridLaunchDarklyProvider");

var _flags = _interopRequireDefault(require("../../../util/flags"));

var _qa = _interopRequireDefault(require("../../../util/qa"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const REACT_APP_GOOGLE_MAPS_API_KEY = "AIzaSyABPDnHB-ZQSQtSg_lmxBMqXKmbw-xxJss";

const getMarkerSrc = ({
  lat,
  lng
}) => `https://maps.googleapis.com/maps/api/staticmap?center=${lat},${lng}&zoom=13&markers=${lat},${lng}&size=400x150&maptype=roadmap&key=${REACT_APP_GOOGLE_MAPS_API_KEY}`;

const Coordinates = _styledComponents.default.div`
  display: flex;
  justify-content: space-between;
  font-size: 11px;
  color: ${_alloyReactTheme.default.colors.charcoal700};
`;
const SubjectLine = _styledComponents.default.div`
  font-size: ${_alloyReactTheme.default.typography.bodySmall.fontSize};
  color: ${_alloyReactTheme.default.colors.charcoal700};
`;
const MapThumbnail = _styledComponents.default.img`
  width: 100%;
  height: 120px;
`;

const DetailsBody = () => {
  var _media$tags;

  const {
    state: {
      media,
      projectTags
    },
    mediaHandlers: {
      editTitleHandler,
      removeTagsHandler,
      addTagsHandler,
      editTitleClickHandler,
      editLocationHandler
    }
  } = (0, _mediaDetailContext.useMedia)();
  const {
    value: showLocations
  } = (0, _PlangridLaunchDarklyProvider.usePlangridFeatureFlag)(_flags.default.LOCATIONS, false);
  const {
    T
  } = (0, _alloyReactHelpers.useLocale)(({
    locale
  }) => require(`../../i18n/${locale}.json`));

  const getLocalizedTag = (tagName, tagType) => {
    if (tagType === "ML") return T.translate(tagName);
    return tagName;
  };

  const selectedTags = (0, _react.useMemo)(() => media.tags ? media.tags.filter(t => t.type === "USER") : [], [media.tags]);
  const existingTags = (0, _react.useMemo)(() => selectedTags.map(t => ({
    value: t.name,
    id: t.name
  })), [selectedTags]);
  const tagOptions = (0, _react.useMemo)(() => projectTags ? (0, _sortBy.default)(projectTags, "name").map(t => ({
    label: getLocalizedTag(t.name, t.type),
    value: t.name
  })) : [], [projectTags]);
  const editTitle = (0, _react.useCallback)(title => editTitleHandler(media, title), [editTitleHandler]);
  const LOCALIZED_AUTOTAGS = {
    "air diffuser": T.translate("AIR_DIFFUSER"),
    bannister: T.translate("BANNISTER"),
    "baseboard finish": T.translate("BASEBOARD"),
    bathtub: T.translate("BATHTUB"),
    cabinet: T.translate("CABINET"),
    "ceiling framing": T.translate("CEILING"),
    "ceiling tile": T.translate("CEILING_TILE"),
    conduit: T.translate("CONDUIT"),
    countertop: T.translate("COUNTERTOP"),
    documents: T.translate("DOCUMENTS"),
    door: T.translate("DOOR"),
    drywall: T.translate("DRYWALL"),
    ductwork: T.translate("DUCTWORK"),
    "electrical cabinet": T.translate("ELECTRICAL_CABINET"),
    "fire seal": T.translate("FIRE_SEAL"),
    "fireproofed steel structure": T.translate("FIREPROOFED_STEEL_STRUCTURE"),
    "floor finish": T.translate("FLOOR_FINISH"),
    formwork: T.translate("FORMWORK"),
    "heavy equipment": T.translate("HEAVY_EQUIPMENT"),
    insulation: T.translate("INSULATION"),
    ladder: T.translate("LADDER"),
    lighting: T.translate("LIGHTING"),
    "metal framing": T.translate("METAL_FRAMING"),
    pavement: T.translate("PAVEMENT"),
    people: T.translate("PEOPLE"),
    rebar: T.translate("REBAR"),
    "repair tape": T.translate("REPAIR_TAPE"),
    sink: T.translate("SINK"),
    "site earthworks": T.translate("SITE_EARTHWORKS"),
    "site utilities": T.translate("SITE_UTILITIES"),
    stairs: T.translate("STAIRS"),
    "steel deck": T.translate("STEEL_DECK"),
    "steel structure": T.translate("STEEL_STRUCTURE"),
    "switches outlets": T.translate("SWITCHES_OUTLETS"),
    tile: T.translate("TILE"),
    toilet: T.translate("TOILET"),
    trench: T.translate("TRENCH"),
    wall: T.translate("WALL"),
    window: T.translate("WINDOW"),
    wiring: T.translate("WIRING"),
    "wood framing": T.translate("WOOD_FRAMING")
  };
  const autoTags = (media === null || media === void 0 ? void 0 : (_media$tags = media.tags) === null || _media$tags === void 0 ? void 0 : _media$tags.reduce((translatedAutoTags, tag) => {
    if (tag.type === "ML") {
      const translatedTagName = LOCALIZED_AUTOTAGS[tag.name] || tag.name;
      return [...translatedAutoTags, ...[{ ...tag,
        ...{
          name: translatedTagName
        }
      }]];
    }

    return translatedAutoTags;
  }, [])) || [];
  const renderTagSelect = (0, _react.useCallback)(({
    onChange
  }) => {
    return /*#__PURE__*/_react.default.createElement(_alloySelectBox.default, {
      searchable: true,
      autoFocus: true,
      multiple: true,
      creatable: true,
      showValueAsTags: true,
      clearInputOnSelect: true,
      options: tagOptions,
      onChange: selection => {
        onChange();

        if (selection) {
          // determine whether tags were added or removed
          const createdTags = (0, _differenceBy.default)(selection, existingTags, "value");
          const removedTags = (0, _differenceBy.default)(existingTags, selection, "value");
          addTagsHandler && createdTags.length > 0 && addTagsHandler(media, createdTags.map(s => ({
            name: s.value,
            type: "USER"
          })));
          removeTagsHandler && removedTags.length > 0 && removeTagsHandler(removedTags.map(s => ({
            name: s.value,
            type: "USER"
          })));
        }
      },
      onCreate: createdOption => {
        onChange();
        const created = createdOption.trim();

        if (created.length > 0 && addTagsHandler) {
          addTagsHandler(media, [{
            name: created,
            type: "USER"
          }]);
        }
      },
      style: {
        border: "none",
        minHeight: 34
      },
      value: existingTags
    });
  }, [existingTags, addTagsHandler, removeTagsHandler, tagOptions]); // TODO: ask locations team to expose container styling
  // this fix is quite hacky. treeStyle prop adds styling to the ul below this parent element
  // for our use case we need the container above it

  const onLocationPickerOpen = () => {
    var _document$querySelect;

    const locationPickerParentNode = (_document$querySelect = document.querySelector(".locationPickerTree")) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.parentNode;

    if (locationPickerParentNode) {
      locationPickerParentNode.style.zIndex = "99999";
    }
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    "data-qa": _qa.default.mediaDetailDetailsBody
  }, /*#__PURE__*/_react.default.createElement(_Spacer.default, {
    height: 20
  }), /*#__PURE__*/_react.default.createElement(SubjectLine, null, T.translate("TITLE")), /*#__PURE__*/_react.default.createElement(_alloyReactInlineEdit.default, {
    value: media.title,
    onEditEnter: () => editTitleClickHandler && editTitleClickHandler(media),
    onChange: editTitle
  }), /*#__PURE__*/_react.default.createElement(_Spacer.default, {
    height: 5
  }), showLocations && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(SubjectLine, null, T.translate("LOCATION")), /*#__PURE__*/_react.default.createElement("div", {
    // TODO: change this to use onOpen prop from locationPicker. doesnt work atm
    onClick: onLocationPickerOpen
  }, /*#__PURE__*/_react.default.createElement(_accLocationsComponents.LocationPicker, {
    clearable: true,
    maxCardHeight: "384px",
    selectedNodeId: media.locationId,
    hideIncludeSubLocations: true,
    treeClassName: "locationPickerTree",
    onNodeSelect: location => {
      if (location && !Array.isArray(location)) {
        editLocationHandler(media, location.id);
      } else if (Array.isArray(location)) {
        location.forEach(l => editLocationHandler(media, l.id));
      } else {
        editLocationHandler(media, null);
      }
    }
  })), /*#__PURE__*/_react.default.createElement(_Spacer.default, {
    height: 5
  })), /*#__PURE__*/_react.default.createElement(SubjectLine, null, T.translate("TAGS")), /*#__PURE__*/_react.default.createElement(_alloyReactInlineEdit.default, {
    value: selectedTags,
    renderValue: values => /*#__PURE__*/_react.default.createElement(_Tags.default, {
      values: values
    }) // @ts-ignore
    ,
    placeholder: T.translate("ADD_TAGS"),
    style: {
      maxWidth: "95%"
    },
    renderInput: renderTagSelect
  }), /*#__PURE__*/_react.default.createElement(_Spacer.default, {
    height: 10
  }), autoTags.length > 0 && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(SubjectLine, null, T.translate("AUTOTAGS")), /*#__PURE__*/_react.default.createElement(_Spacer.default, {
    height: 6
  }), /*#__PURE__*/_react.default.createElement(_Tags.default, {
    values: autoTags,
    leadingSpace: 15,
    tagStyle: {
      backgroundColor: _alloyReactTheme.default.colors.adskBlue100
    }
  }), /*#__PURE__*/_react.default.createElement(_Spacer.default, {
    height: 10
  })), media.location && media.location.lng && media.location.lat && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(SubjectLine, null, T.translate("GPS_LOCATION")), /*#__PURE__*/_react.default.createElement(_Spacer.default, {
    height: 6
  }), /*#__PURE__*/_react.default.createElement("a", {
    target: "_blank",
    href: _routes.getRoute.mapWithMedia(media.uid),
    rel: "noreferrer"
  }, /*#__PURE__*/_react.default.createElement(MapThumbnail, {
    src: media.location ? getMarkerSrc(media.location) : "",
    alt: "location map"
  })), /*#__PURE__*/_react.default.createElement(_Spacer.default, {
    height: 6
  }), /*#__PURE__*/_react.default.createElement(Coordinates, null, /*#__PURE__*/_react.default.createElement("div", null, T.translate("COORDINATES")), /*#__PURE__*/_react.default.createElement("div", null, media.location.lat, ", ", media.location.lng))));
};

var _default = DetailsBody;
exports.default = _default;